// extracted by mini-css-extract-plugin
export var deskImage = "FinestTeaBanner-module--desk-Image--64286";
export var imgContainer = "FinestTeaBanner-module--imgContainer--8c78d";
export var mobImage = "FinestTeaBanner-module--mob-Image--ea16c";